/*
  Guias de compra: lista para conferir (guardada no aparelho), impressão só da lista
  e filtro da página de guias. A entrada suave, o índice e as âncoras vêm de curadorias.js.
*/
(function () {
  function read(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      return [];
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      /* Sem armazenamento (aba anônima): a lista funciona, só não fica guardada. */
    }
  }

  function initCheck(box) {
    const key = 'inusual-guia-' + box.dataset.guCheck;
    const inputs = [...box.querySelectorAll('[data-gu-item]')];
    const count = box.querySelector('[data-gu-count]');
    const total = inputs.length;
    const saved = new Set(read(key));

    function update() {
      const done = inputs.filter((input) => input.checked).length;
      if (count) count.textContent = done + ' de ' + total + (done === 1 ? ' conferido' : ' conferidos');
    }

    inputs.forEach((input) => {
      input.checked = saved.has(input.dataset.guItem);
      input.addEventListener('change', () => {
        write(
          key,
          inputs.filter((item) => item.checked).map((item) => item.dataset.guItem)
        );
        update();
      });
    });
    update();

    const print = box.querySelector('[data-gu-print]');
    if (print) {
      print.addEventListener('click', () => {
        document.body.classList.add('gu-printing');
        window.print();
      });
      window.addEventListener('afterprint', () => document.body.classList.remove('gu-printing'));
    }
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  }

  function initHub(hub) {
    const buttons = [...hub.querySelectorAll('[data-gu-filter]')];
    const cards = [...hub.querySelectorAll('[data-gu-card]')];
    const count = hub.querySelector('[data-gu-count]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = normalize(button.dataset.guFilter);
        let visible = 0;

        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach((card) => {
          const show = !filter || normalize(card.dataset.categoria) === filter;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = visible === 1 ? '1 guia' : visible + ' guias';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-gu-check]').forEach(initCheck);
    document.querySelectorAll('[data-gu-hub]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
